// @ts-nocheck
import debounce from "lodash/debounce";
import { useEffect, useRef } from "react";

type SomeFunction = (...args: any[]) => void;

export function useDebounce<Func extends SomeFunction>(func: Func, delay = 1000) {
    const debouncedRef = useRef<ReturnType<typeof debounce>>();

    useEffect(() => {
        debouncedRef.current = debounce(func, delay);

        return () => {
            debouncedRef.current?.cancel();
        };
    }, [func, delay]);

    return ((...args) => {
        debouncedRef.current?.(...args);
    }) as Func;
}
